import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=3da4dd44&scoped=true&"
import script from "./selection.vue?vue&type=script&lang=ts&"
export * from "./selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4dd44",
  null
  
)

export default component.exports